import { allpeepPayloadEndpoint } from './helpers.js';
import { allpeepNoPayloadEndpoint } from './helpers.js';
export const admin = (rawClient) => ({
    accounts: {
        list: allpeepNoPayloadEndpoint(rawClient, '/admin/accounts'),
        findById: allpeepNoPayloadEndpoint(rawClient, '/admin/accounts/:id'),
        update: allpeepPayloadEndpoint(rawClient, '/admin/accounts/:id', 'patch'),
        delete: allpeepNoPayloadEndpoint(rawClient, '/admin/accounts/:id', 'delete'),
    },
    backups: {
        list: allpeepNoPayloadEndpoint(rawClient, '/admin/backups'),
        create: allpeepNoPayloadEndpoint(rawClient, '/admin/backups', 'post'),
        restore: allpeepPayloadEndpoint(rawClient, '/admin/backups/restore', 'post'),
    },
    config: {
        read: allpeepNoPayloadEndpoint(rawClient, '/admin/config/:namespace/:name'),
        update: allpeepPayloadEndpoint(rawClient, '/admin/config/:namespace/:name', 'patch'),
    },
    configuration: {
        email: {
            sendTest: allpeepPayloadEndpoint(rawClient, '/admin/configuration/email/test', 'post'),
        },
    },
    diagnostics: {
        email: {
            queueStats: allpeepNoPayloadEndpoint(rawClient, '/admin/diagnostics/email/queue-stats'),
            queueTest: allpeepPayloadEndpoint(rawClient, '/admin/diagnostics/email/test', 'post'),
        },
        jobs: {
            jobDetail: allpeepNoPayloadEndpoint(rawClient, '/admin/diagnostics/jobs/:queue/:jobId'),
        },
        performance: allpeepNoPayloadEndpoint(rawClient, '/admin/diagnostics/performance'),
    },
    db: {
        token: allpeepNoPayloadEndpoint(rawClient, '/admin/db/token'),
        tables: allpeepNoPayloadEndpoint(rawClient, '/admin/db/tables'),
        rows: allpeepNoPayloadEndpoint(rawClient, '/admin/db/tables/:table/rows'),
        updateRow: allpeepPayloadEndpoint(rawClient, '/admin/db/tables/:table/rows', 'put'),
        exportCsv: async (table, query) => {
            const params = new URLSearchParams();
            if (query) {
                for (const [key, value] of Object.entries(query)) {
                    if (value != null && value !== '') {
                        params.set(key, String(value));
                    }
                }
            }
            const qs = params.toString();
            const path = `/admin/db/tables/${encodeURIComponent(table)}/export${qs ? `?${qs}` : ''}`;
            const response = await rawClient.get(path);
            if (!response.ok) {
                throw Object.assign(Object.assign({}, (await response.json())), { status: response.status });
            }
            return response.text();
        },
        runSql: allpeepPayloadEndpoint(rawClient, '/admin/db/sql', 'post'),
    },
    i18n: {
        read: allpeepNoPayloadEndpoint(rawClient, '/admin/i18n'),
        update: allpeepPayloadEndpoint(rawClient, '/admin/i18n/overrides', 'put'),
    },
    invites: {
        create: allpeepPayloadEndpoint(rawClient, '/invite-links'),
        list: allpeepNoPayloadEndpoint(rawClient, '/invite-links'),
        activate: allpeepNoPayloadEndpoint(rawClient, '/invite-links/:id/activate', 'put'),
        deactivate: allpeepNoPayloadEndpoint(rawClient, '/invite-links/:id/deactivate', 'put'),
    },
    logs: {
        list: allpeepNoPayloadEndpoint(rawClient, '/admin/logs'),
    },
    posts: {
        pinGlobally: allpeepPayloadEndpoint(rawClient, '/admin/pinned-post', 'patch'),
        announce: allpeepNoPayloadEndpoint(rawClient, '/admin/posts/:id/announce', 'post'),
    },
    profiles: {
        list: allpeepNoPayloadEndpoint(rawClient, '/admin/profiles'),
        exportCsv: async () => {
            const response = await rawClient.get('/admin/profiles/export');
            if (!response.ok) {
                throw Object.assign(Object.assign({}, (await response.json())), { status: response.status });
            }
            return response.text();
        },
        listByAccount: allpeepNoPayloadEndpoint(rawClient, '/admin/profiles/by-account/:id'),
        delete: allpeepNoPayloadEndpoint(rawClient, '/admin/profiles/:id', 'delete'),
        listRoles: allpeepNoPayloadEndpoint(rawClient, '/admin/profiles/:id/roles'),
        updateRoles: allpeepPayloadEndpoint(rawClient, '/admin/profiles/:id/roles', 'put'),
        activitySummary: allpeepNoPayloadEndpoint(rawClient, '/admin/profiles/:id/activity-summary'),
    },
    roles: {
        list: allpeepNoPayloadEndpoint(rawClient, '/admin/roles'),
        create: allpeepPayloadEndpoint(rawClient, '/admin/roles', 'post'),
        update: allpeepPayloadEndpoint(rawClient, '/admin/roles/:roleId', 'put'),
    },
    stats: {
        general: allpeepNoPayloadEndpoint(rawClient, '/admin/stats'),
    },
    analytics: {
        overview: allpeepNoPayloadEndpoint(rawClient, '/admin/analytics/overview'),
        growth: allpeepNoPayloadEndpoint(rawClient, '/admin/analytics/growth'),
        engagement: allpeepNoPayloadEndpoint(rawClient, '/admin/analytics/engagement'),
        retention: allpeepNoPayloadEndpoint(rawClient, '/admin/analytics/retention'),
        clicks: allpeepNoPayloadEndpoint(rawClient, '/admin/analytics/clicks'),
        reportSettings: {
            read: allpeepNoPayloadEndpoint(rawClient, '/admin/analytics/report-settings'),
            update: allpeepPayloadEndpoint(rawClient, '/admin/analytics/report-settings', 'put'),
        },
        export: allpeepNoPayloadEndpoint(rawClient, '/admin/analytics/export'),
        backfill: allpeepPayloadEndpoint(rawClient, '/admin/analytics/backfill', 'post'),
    },
    reports: {
        list: allpeepNoPayloadEndpoint(rawClient, '/admin/reports'),
        findById: allpeepNoPayloadEndpoint(rawClient, '/admin/reports/:reportId'),
        resolve: allpeepPayloadEndpoint(rawClient, '/admin/reports/:reportId/resolve', 'put'),
        reopen: allpeepNoPayloadEndpoint(rawClient, '/admin/reports/:reportId/reopen', 'put'),
    },
    groups: {
        list: allpeepNoPayloadEndpoint(rawClient, '/admin/groups'),
        delete: allpeepNoPayloadEndpoint(rawClient, '/admin/groups/:groupId', 'delete'),
    },
    serviceAccessTokens: {
        list: allpeepNoPayloadEndpoint(rawClient, '/admin/service-access-tokens'),
        create: allpeepPayloadEndpoint(rawClient, '/admin/service-access-tokens', 'post'),
        revoke: allpeepNoPayloadEndpoint(rawClient, '/admin/service-access-tokens/:accessTokenId', 'delete'),
    },
    plugins: {
        list: allpeepNoPayloadEndpoint(rawClient, '/admin/plugins'),
        install: allpeepPayloadEndpoint(rawClient, '/admin/plugins/install', 'post'),
        uninstall: allpeepNoPayloadEndpoint(rawClient, '/admin/plugins/:namespace/:name', 'delete'),
        update: allpeepPayloadEndpoint(rawClient, '/admin/plugins/:namespace/:name', 'patch'),
        reload: allpeepNoPayloadEndpoint(rawClient, '/admin/plugins/reload', 'post'),
    },
});
